import CustomNavbar from './Components/Navbar/CustomNavbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import MainNavbarMenu from './Components/Navbar/MainNavbarMenu';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ProductsPage from './Pages/ProductsPage';
import NewsEventsPage from './Pages/NewsEventsPage';
import HansaFlexGroupPage from './Pages/HansaFlexGroupPages/HansaFlexGroupPage';
import HomePage from './Pages/HomePage';

import HfFooter from './Components/HfFooter/HfFooter';
import Journey from './Pages/HansaFlexSerbiaPages/Journey';
import Management from './Pages/HansaFlexSerbiaPages/Management';
import GroupManagement from './Pages/HansaFlexGroupPages/GroupManagement';
import GroupHistory from './Pages/HansaFlexGroupPages/GroupHistory';
import GroupMissionStatement from './Pages/HansaFlexGroupPages/GroupMissionStatement';
import Certificates from './Pages/HansaFlexSerbiaPages/Certificates';

import SixtyYearOfHansaflex from './Pages/HansaFlexGroupPages/SixtyYearOfHansaFlex';
import Careers from './Pages/Careers';
import PrivayPolicyPage from './Pages/PrivacyPolicy';
import CookieConsent from 'react-cookie-consent';



import HosesAndHoseLines from './Pages/ProductPages/HosesAndHoseLines/HosesAndHoseLines';
import HydraulicHose from './Pages/ProductPages/HosesAndHoseLines/HydraulicHose';
import MetalHoses from './Pages/ProductPages/HosesAndHoseLines/MetalHoses';
import IndustrialHoses from './Pages/ProductPages/HosesAndHoseLines/IndustrialHoses';
import PerformedHoses from './Pages/ProductPages/HosesAndHoseLines/PerformedHoses';
import ExtremelyHighPerformanceHoses from './Pages/ProductPages/HosesAndHoseLines/ExtremelyHighPerformanceHoses';
import HoseLineConfigurator from './Pages/ProductPages/HosesAndHoseLines/HoseLineConfigurator';
import PtfeHoses from './Pages/ProductPages/HosesAndHoseLines/PtfeHoses';
import Accessories from './Pages/ProductPages/HosesAndHoseLines/Accessories';
import DriveAndControlTechnology from './Pages/ProductPages/DriveAndControlTechnology/DriveAndControlTechnology';
import Pumps from './Pages/ProductPages/DriveAndControlTechnology/Pumps';
import HydraulicMotor from './Pages/ProductPages/DriveAndControlTechnology/HydraulicMotor';
import Cylinder from './Pages/ProductPages/DriveAndControlTechnology/Cylinder';
import SwitchesAndSensors from './Pages/ProductPages/DriveAndControlTechnology/SwitchesAndSensors';
import ValveTechnology from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/ValveTechnology';
import PipelineInstallationValve from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/PipelineInstallationValve';
import CartridgeValves from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/CartridgeValves';
import CetopValves from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/CetopValves';
import MeasuringTechnology from './Pages/ProductPages/DriveAndControlTechnology/MeasuringTechnology';
import SevenHundredBarHydraulics from './Pages/ProductPages/DriveAndControlTechnology/SevenHundredBarHydraulics';
import PressureAccumulators from './Pages/ProductPages/DriveAndControlTechnology/PressureAccumulators';
import SealingTechnology from './Pages/ProductPages/SealingTechnology';
import Filtration from './Pages/ProductPages/Filtration';
import Pneumatics from './Pages/ProductPages/Pneumatics';
import TechnicalInformation from './Pages/ProductPages/TechnicalInformation';
import Approvals from './Pages/ProductPages/Approvals';
import Catalogues from './Pages/ProductPages/Catalogues';
import HydraulicConnectionTechnology from './Pages/ProductPages/HydraulicConnectionTechnology/HydraulicConnectionTechnology';
import HoseFittings from './Pages/ProductPages/HydraulicConnectionTechnology/HoseFittings';
import PipeFittings from './Pages/ProductPages/HydraulicConnectionTechnology/PipeFittings';
import Adapters from './Pages/ProductPages/HydraulicConnectionTechnology/Adapters';
import Couplings from './Pages/ProductPages/HydraulicConnectionTechnology/Couplings';
import BallValves from './Pages/ProductPages/HydraulicConnectionTechnology/BallValves';
import Flanges from './Pages/ProductPages/HydraulicConnectionTechnology/Flanges';
import Pipelines from './Pages/ProductPages/Pipelines/Pipelines';
import Pipebends from './Pages/ProductPages/Pipelines/Pipebends';
import ExpansionJoints from './Pages/ProductPages/Pipelines/ExpansionJoints';
import PipeendProcessing from './Pages/ProductPages/Pipelines/PipeendProcessing';


import HoseManagement from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/HoseManagement';
import FluidService from './Pages/ServicesPages/FluidManagement/FluidService';
import MobileService from './Pages/ServicesPages/MobileRapidHydraulicService';
import HydraulicAcademy from './Pages/ServicesPages/HydraulicAccademy';
import OilAnalysis from './Pages/ServicesPages/FluidManagement/OilAnalysis';
import OilFilteringAndCleaning from './Pages/ServicesPages/FluidManagement/OilFilteringAndCleaning';
import AssemblyAndInstallation from './Pages/ServicesPages/AssembellyAndInstallation/AssemblyAndInstallation';
import ModernisationAndOptimisation from './Pages/ServicesPages/AssembellyAndInstallation/ModernisationAndOptimisation';
import PlantProjectPlanningAndManagement from './Pages/ServicesPages/AssembellyAndInstallation/PlantProjectPlanningAndManagement';
import InstallationOfPipeAndHoseLineSystems from './Pages/ServicesPages/AssembellyAndInstallation/InstallationOfPipeAndHoseLineSystems';
import PreventataiveMaintainance from './Pages/ServicesPages/PreventativeMaintainance/PreventataiveMaintainance';
import ServicePackages from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/ServicePackages';
import XCodeIdentification from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeIdentification';
import XCodeManager from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeManager/XCodeManager';
import Licenses from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeManager/Licenses';
import Inspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/Inspection';
import IndustrialHoseInspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/IndustrialHoseInspection';
import DguvInspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/DguvInspection';
import LiftingPlatformsAndLoadingBridges from './Pages/ServicesPages/PreventativeMaintainance/Inspection/LiftingPlatformsAndLoadingBridges';
import RepairAndOverhaul from './Pages/ServicesPages/RepairAndOverhaul/RepairAndOverhaul';
import PressureAccumulatorsAndAssociatedSystems from './Pages/ServicesPages/RepairAndOverhaul/PressureAccumulatorsAndAssociatedSystems';
import HydraulicCylinderRepair from './Pages/ServicesPages/RepairAndOverhaul/HydraulicCylinderRepair';
import DigitalServices from './Pages/ServicesPages/Digital Services/DigitalServices';
import EDIandBMEcat from './Pages/ServicesPages/Digital Services/EDIandBMEcat';
import Scannersolutions from './Pages/ServicesPages/Digital Services/Scannersolutions';
import Production from './Pages/ServicesPages/Production/Production';
import CustomisedAssembly from './Pages/ServicesPages/Production/CustomisedAssembly';
import SeriesProduction from './Pages/ServicesPages/Production/SeriesProduction';

import Logisticssolutions from './Pages/ServicesPages/Logistics solutions/Logisticssolutions';
import Warehousemanagement from './Pages/ServicesPages/Logistics solutions/Warehousemanagement';
import Kanbandelivery from './Pages/ServicesPages/Logistics solutions/Kanbandelivery'
import Kitting from './Pages/ServicesPages/Logistics solutions/Kitting';
import Hydraulicworkshopcontainers from './Pages/ServicesPages/Logistics solutions/Hydraulicworkshopcontainers';
import Worksinworks from './Pages/ServicesPages/Logistics solutions/Worksinworks';

import Engineering from './Pages/ServicesPages/Enginnering/Engineering';
import EngineeredbyHansaflex from './Pages/ServicesPages/Enginnering/EngineeredbyHansaflex';
import Hydraulicunit from './Pages/ServicesPages/Enginnering/Hydraulicunit';
import Prototypemanufacture from './Pages/ServicesPages/Enginnering/Prototypemanufacture';
import Pressureaccumulatorinspection from './Pages/ServicesPages/Pressureaccumulatorinspection';

import WhoWeAre from './Pages/HansaFlexSerbiaPages/WhoWeAre';
import ContactUs from './Pages/HansaFlexSerbiaPages/ContactUs';
import AnnualReport from './Pages/HansaFlexGroupPages/AnnualReport';
import UpcomingEvents from './Pages/HansaFlexGroupPages/UpcomingEvents';
import Associations from './Pages/HansaFlexGroupPages/Associations';
import ResponsibilityAndSocialCommitments from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/ResponsibilityAndSocialCommitments';
import DonationInsteadGifts from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/DonationInsteadGifts';
import Diversity from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/Diversity';
import Branch1 from './Pages/HansaFlexSerbiaPages/Branches/Branch1';
import Branch2 from './Pages/HansaFlexSerbiaPages/Branches/Branch2';
import Branch3 from './Pages/HansaFlexSerbiaPages/Branches/Branch3';
import Branch4 from './Pages/HansaFlexSerbiaPages/Branches/Branch4';
import Branch5 from './Pages/HansaFlexSerbiaPages/Branches/Branch5';
import Branch6 from './Pages/HansaFlexSerbiaPages/Branches/Branch6';
import Branch7 from './Pages/HansaFlexSerbiaPages/Branches/Branch7';
import Branch8 from './Pages/HansaFlexSerbiaPages/Branches/Branch8';
import Branch9 from './Pages/HansaFlexSerbiaPages/Branches/Branch9';
import Branch10 from './Pages/HansaFlexSerbiaPages/Branches/Branch10';

// import CookieConsent from 'react-cookie-consent';


function App() {


  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <div className='primary-navbar'>
            <CustomNavbar />
          </div>

        </header>
        <div className='secondary-navbar sticky-top '>
          <MainNavbarMenu />
        </div>
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/products" component={ProductsPage} />
          <Route path="/news-events" component={NewsEventsPage} />
          <Route path="/hf-group" component={HansaFlexGroupPage} />
          <Route path="/contact-us" component={ContactUs} />

          <Route path="/who-we-are" component={WhoWeAre} />
          <Route path="/journey" component={Journey} />
          <Route path="/certificates" component={Certificates} />
          <Route path="/careers" component={Careers} />
          <Route path="/management" component={Management} />
          <Route path="/branch-1" component={Branch1} />
          <Route path="/branch-2" component={Branch2} />
          <Route path="/branch-3" component={Branch3} />
          <Route path="/branch-4" component={Branch4} />
          <Route path="/branch-5" component={Branch5} />
          <Route path="/branch-6" component={Branch6} />
          <Route path="/branch-7" component={Branch7} />
          <Route path="/branch-8" component={Branch8} />
          <Route path="/branch-9" component={Branch9} />
          <Route path="/branch-10" component={Branch10} />
          <Route path="/hansa-flex-india-privacy-policy" component={PrivayPolicyPage} />

          <Route path="/hf-group-management" component={GroupManagement} />
          <Route path="/hf-group-history" component={GroupHistory} />
          <Route path="/hf-group-mission-statement" component={GroupMissionStatement} />
          <Route path="/hf-60-years-of-hansaflex" component={SixtyYearOfHansaflex} />
          <Route path="/annual-report" component={AnnualReport} />
          <Route path="/upcoming-events" component={UpcomingEvents} />
          <Route path="/associations" component={Associations} />
          <Route path="/responsibility-and-social-commitments" component={ResponsibilityAndSocialCommitments} />
          <Route path="/donation-instead-gifts" component={DonationInsteadGifts} />
          <Route path="/diversity" component={Diversity} />


          {/* HF Products Pages */}
          <Route path="/products" component={ProductsPage} />
          <Route path="/hoses-and-hose-lines" component={HosesAndHoseLines} />
          <Route path="/hose-line-config" component={HoseLineConfigurator} />
          <Route path="/hydraulic-hoses" component={HydraulicHose} />
          <Route path="/metal-hoses" component={MetalHoses} />
          <Route path="/Industrial-hoses" component={IndustrialHoses} />
          <Route path="/performed-hoses" component={PerformedHoses} />
          <Route path="/ext-high-pfm-hoses" component={ExtremelyHighPerformanceHoses} />
          <Route path="/Ptfe-hoses" component={PtfeHoses} />
          <Route path="/hose-accessories" component={Accessories} />

          <Route path="/drive-and-control-tech" component={DriveAndControlTechnology} />
          <Route path="/pumps" component={Pumps} />
          <Route path="/hydraulic-motor" component={HydraulicMotor} />
          <Route path="/cylinder" component={Cylinder} />
          <Route path="/switches-and-sensors" component={SwitchesAndSensors} />
          <Route path="/valve-tech" component={ValveTechnology} />
          <Route path="/pipeline-installation-valve" component={PipelineInstallationValve} />
          <Route path="/cartridge-valve" component={CartridgeValves} />
          <Route path="/cetop-valve" component={CetopValves} />
          <Route path="/measuring-tech" component={MeasuringTechnology} />
          <Route path="/seven-hundred-hydraulics" component={SevenHundredBarHydraulics} />
          <Route path="/pressure-accumulators" component={PressureAccumulators} />

          <Route path="/hydraulic-connection-technology" component={HydraulicConnectionTechnology} />
          <Route path="/hose-fitting" component={HoseFittings} />
          <Route path="/pipe-fitting" component={PipeFittings} />
          <Route path="/adapters" component={Adapters} />
          <Route path="/coupling" component={Couplings} />
          <Route path="/ball-valves" component={BallValves} />
          <Route path="/flanges" component={Flanges} />

          <Route path="/sealing-tech" component={SealingTechnology} />
          <Route path="/filtration" component={Filtration} />
          <Route path="/pneumatics" component={Pneumatics} />
          <Route path="/technical-information" component={TechnicalInformation} />
          <Route path="/approvals" component={Approvals} />
          <Route path="/catalogues" component={Catalogues} />

          <Route path="/pipelines" component={Pipelines} />
          <Route path="/pipebends" component={Pipebends} />
          <Route path="/pipeend-processing" component={PipeendProcessing} />
          <Route path="/Expansionjoints" component={ExpansionJoints} />

          {/* HF Services Pages */}
          <Route path="/hose-management" component={HoseManagement} />
          <Route path="/mobile-rapid-hydraulic-service" component={MobileService} />
          <Route path="/hydraulic-academy" component={HydraulicAcademy} />

          <Route path="/fluid-service" component={FluidService} />
          <Route path="/oil-analysis" component={OilAnalysis} />
          <Route path="/oil-filtering-and-cleaning" component={OilFilteringAndCleaning} />

          <Route path="/assembly-and-installation" component={AssemblyAndInstallation} />
          <Route path="/modernisation-and-optimisation" component={ModernisationAndOptimisation} />
          <Route path="/plant-project-planning-and-management" component={PlantProjectPlanningAndManagement} />
          <Route path="/installation-of-pipe-and-hoseline-systems" component={InstallationOfPipeAndHoseLineSystems} />

          <Route path="/preventative-maintainance" component={PreventataiveMaintainance} />
          <Route path="/service-packages" component={ServicePackages} />
          <Route path="/x-code-hose-identification-system" component={XCodeIdentification} />
          <Route path="/x-code-manager" component={XCodeManager} />
          <Route path="/licenses" component={Licenses} />
          <Route path="/inspection" component={Inspection} />
          <Route path="/industrial-hose-inspection" component={IndustrialHoseInspection} />
          <Route path="/dguv-inspection" component={DguvInspection} />
          <Route path="/lifting-platforms-and-loading-bridges" component={LiftingPlatformsAndLoadingBridges} />

          <Route path="/repair-and-overhaul" component={RepairAndOverhaul} />
          <Route path="/hydraulic-cyclinder-repair" component={HydraulicCylinderRepair} />
          <Route path="/pressure-accumulators-and-associated-systems" component={PressureAccumulatorsAndAssociatedSystems} />

          <Route path="/DigitalServices" component={DigitalServices} />
          <Route path="/EDIandBMEcat" component={EDIandBMEcat} />
          <Route path="/Scannersolutions" component={Scannersolutions} />
          <Route path="/Production" component={Production} />
          <Route path="/Customisedassembly" component={CustomisedAssembly} />
          <Route path="/SeriesProduction" component={SeriesProduction} />

          <Route path="/Logisticssolutions" component={Logisticssolutions} />
          <Route path="/Warehousemanagement" component={Warehousemanagement} />
          <Route path="/Kanbandelivery" component={Kanbandelivery} />
          <Route path="/Kitting" component={Kitting} />
          <Route path="/Hydraulicworkshopcontainers" component={Hydraulicworkshopcontainers} />
          <Route path="/Worksinworks" component={Worksinworks} />

          <Route path="/Engineering" component={Engineering} />
          <Route path="/EngineeredbyHansaflex" component={EngineeredbyHansaflex} />
          <Route path="/Hydraulicunit" component={Hydraulicunit} />
          <Route path="/Prototypemanufacture" component={Prototypemanufacture} />

          <Route path="/Pressureaccumulatorinspection" component={Pressureaccumulatorinspection} />

        </Switch>

        <div>
          <HfFooter />
        </div>
        <CookieConsent
          location="bottom"
          buttonText="Accept"
          cookieName="HFCookieConsent"
          style={{ background: '#4571a2', color: '#fff', textAlign: 'center' }}
          buttonStyle={{ color: '#fff', backgroundColor: '#d40606', fontSize: '14px' }}
          expires={365}
        >
          This website uses cookies to enhance the user experience.
        </CookieConsent>
      </div>
    </Router>
  );
}

export default App;
